import util from '@bmp-vue/core/api/util'
const controller = 'Lucash'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  Get (anoFab, th) {
    var anoFim = anoFab >= th.$param.AnoFim_Inicio.anoFim ? anoFab : th.$param.AnoFim_Inicio.anoFim
    var anoInicio = anoFab <= th.$param.AnoFim_Inicio.anoInicio ? anoFab : th.$param.AnoFim_Inicio.anoInicio
    const tabela = th.$param.TabelaTaxas.map(l => {
      if (l.anoInicio === 'anoInicio') {
        l.anoInicio = anoInicio
      } else if (l.anoFim === 'anoFim') {
        l.anoFim = anoFim
      }
      return l
    })
    return tabela
  },
  GetItem (modelo, prazo, anoFab, th) {
    var result = null
    if (anoFab && prazo && (modelo || modelo === 0)) {
      const item = ctrl.Get(anoFab, th).find(p => anoFab <= p.anoFim && anoFab >= p.anoInicio && prazo === p.prazo)
      var mod = Object.keys(item).find(l => {
        if (l.includes(modelo)) {
          return l
        }
      })
      result = { anoInicio: item.anoInicio, anoFim: item.anoFim, prazo: item.prazo, taxa: item[mod], entrada: item.entrada }
    } else if (th.model.PropostaDadosVeiculo.AnoFab) {
      anoFab = th.model.PropostaDadosVeiculo.AnoFab
      const item = ctrl.Get(anoFab, th).find(p => anoFab <= p.anoFim && anoFab >= p.anoInicio).entrada
      result = item
    }
    return result
  },
  VlrEntradaRules (th) {
    if ((th.model.ModeloComissao || th.model.ModeloComissao === 0) && th.model.Parcelas && th.model.PropostaDadosVeiculo.AnoFab) {
      var entrada = ctrl.GetItem(th.model.ModeloComissao, th.model.Parcelas, th.model.PropostaDadosVeiculo.AnoFab, th).entrada
      return [
        th.model.VlrEntrada < th.model.VlrProdutoBem || 'O Valor da Entrada deve ser menor que Valor do Veículo',
        th.model.VlrEntrada >= (th.model.VlrProdutoBem * entrada).toFixed(2) || 'O Valor da Entrada deve ser pelo menos ' + (entrada * 100) + '% do Valor do Veículo'
      ]
    }
  },
  GetTaxa (th) {
    var taxa = 0
    const tx = ctrl.GetItem(th.model.ModeloComissao, th.model.Parcelas, th.model.PropostaDadosVeiculo.AnoFab, th)
    if (tx) {
      taxa = tx.taxa
    }
    th.$set(th.model, 'PercJurosMensal', taxa)
  },
  ChangeVlrProdutoBem (th, value) {
    let vlrEntrada = 0
    const PercEntrada = ctrl.GetItem(null, null, null, th)
    if (value) {
      value = th.$api.UI.Parse.Decimal(value)
      vlrEntrada = parseFloat((value * PercEntrada).toFixed(2))
    }
    th.$set(th.model, 'VlrEntrada', vlrEntrada)
  },
  SavePropostaCampoAuxiliar (th) {
    const campos = []

    if ([null, undefined].indexOf(th.model.PropostaDadosVeiculo.ZeroKM) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTAVEICULO_ZEROKM', ValorCampo: th.model.PropostaDadosVeiculo.ZeroKM }) }
    if ([null, undefined].indexOf(th.model.ModeloComissao) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_MODELOCOMISSAO', ValorCampo: th.model.ModeloComissao }) }
    if ([null, undefined].indexOf(th.model.ObservacaoVendedor) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_OBSERVACAOVENDEDOR', ValorCampo: th.model.ObservacaoVendedor }) }

    if (campos.length > 0) { th.$api.Multiplo.Post('SavePropostaCampoAuxiliar', { dto: campos }) }
  },
  AllowedDates (th, value) {
    return ![0, 6].includes(th.$api.UI.Parse.Date(value).getDay())
  },
  incluirProposta (th, callback) {
    if (!th.model.Codigo) {
      ctrl.salvarProposta(th, function () {
        ctrl.SavePropostaCampoAuxiliar(th)
        ctrl.salvarVeiculo(th, callback)
      })
    } else {
      ctrl.SavePropostaCampoAuxiliar(th)
      ctrl.salvarVeiculo(th)
      callback()
    }
  },
  salvarProposta (th, callback) {
    if (!th.$api.Proposta.ValidarValorGravame(th.model.VlrOutrosServicos)) {
      return
    }
    var dto = {
      dto: {
        ...th.model,
        ...th.model.selecionado,
        PercJurosNegociado: th.model.PercJurosMensal,
        DocumentoCliente: th.model.Pessoa.DocumentoFederal,
        Prazo: th.model.Parcelas,
        DocumentoParceiroCorrespondente: th.$api.UI.Format.SomenteAlfanumerico(th.$empresa.documentoFederal)
      }
    }
    th.$api.Multiplo.Post('IncluirPropostaManualSimplificado', dto).then(function (proposta) {
      if (th.$api.UI.PostLoadData(proposta, true)) {
        th.$set(th.model, 'Codigo', proposta.Codigo)
        if (callback) {
          callback()
        }
      }
    })
  },
  salvarVeiculo (th, callback) {
    th.model.PropostaDadosVeiculo.CodigoProposta = th.model.Codigo
    var veiculo = { ...th.model.PropostaDadosVeiculo }
    if (veiculo) {
      th.$set(veiculo, 'Placa', veiculo.Placa)
      th.$set(veiculo, 'Chassis', null)
      th.$set(veiculo, 'TipoVeiculo', th.model.PropostaDadosVeiculo.TipoVeiculo)
      th.$set(veiculo, 'TipoChassi', 2)
      th.$set(veiculo, 'TipoRestricaoGravame', 3)
      th.$set(veiculo, 'TipoRestricao', 3)

      const dtoVeiculo = {
        dto: {
          dto: {
            CodigoProposta: th.model.Codigo,
            CodigoOperacao: th.model.CodigoOperacao,
            NumeroProposta: th.model.CodigoPropostaAN
          },
          dadosVeiculoDTO: {
            ...veiculo,
            ignorarCpfRenave: true
          }
        }
      }
      th.$api.Multiplo.Post(
        'CreateUpdatePropostaDadosVeiculo',
        dtoVeiculo
      ).then(function (response) {
        th.$api.Helper.RetornoRenave(th, response, callback)
      })
    }
  },
  TipoErroGravameEnum: {
    Externo: 1,
    Interno: 2
  },
})

export default ctrl
